<template>
  <div class="card-shipping-fee-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header title="Editar">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'card-shipping-fees.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <card-shipping-fee-form
        @submit="onSubmit"
        :id="cardShippingFeeId"
        :errors="errors"
        :saving="isSaving"
      ></card-shipping-fee-form>
    </app-card>
  </div>
</template>

<script>
import CardShippingFeeForm from '@/components/Forms/CardShippingFeeForm.vue';
import CardShippingFeesService from '@/services/card-shipping-fee.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'card-shipping-fee-form-page',
  mixins: [ToastMixin],
  components: {
    CardShippingFeeForm,
  },
  data: () => {
    return {
      cardShippingFeeId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      this.cardShippingFeeId && this.update(this.cardShippingFeeId, data);
    },
    update(id, data) {
      this.isSaving = true;
      CardShippingFeesService.update(id, data)
        .then(() => {
          this.toastify('Taxa atualizada com sucesso!');
          this.$router.push({ name: 'card-shipping-fees.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(message || 'Erro ao tentar atualizar Taxa', 'error');
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.cardShippingFeeId = this.$route.params.id;
  },
};
</script>

<style lang="sass" scoped></style>
